
import { TypedMoney } from "@commercetools/platform-sdk";
import { AssetType, type EnrichedSwarovskiProductVariantDiscountedPriceFrontend } from "@swo/shared";
import { pipe } from "fp-ts/lib/function";
import * as RNEA from "fp-ts/lib/ReadonlyNonEmptyArray";
import { NonEmptyArray } from "fp-ts/NonEmptyArray";
import { ContentContainer } from "../../../components/_shared-components/arrangement/Container";
import { Spacer } from "../../../components/_shared-components/arrangement/Space";
import { PDPProductsCarouselComponent } from "../../../components/ProductsCarouselComponent/PDPProductsCarouselComponent";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import type { TranslatedValue } from "@swo/storefront";
import { hasDiscount } from "../../../domain/products";

export type PDPCarouselProducts = {
  headline: string;
  price: TypedMoney;
  discountedPrice: EnrichedSwarovskiProductVariantDiscountedPriceFrontend;
  image: AssetType | undefined;
  productId: string;
  variantId: number;
  sku: string;
  internalLink: string;
};

export const ProductDetailPageCarousel: ReactTFC<{
  headline: TranslatedValue;
  products: NonEmptyArray<PDPCarouselProducts>;
  hidePrice?: boolean;
  noLink?: boolean;
  theme?: "standard" | "wide-with-background";
}> = props => {
  const elements = pipe(
    props.products,
    RNEA.map(p => ({
      ...p,
      price: props.hidePrice ? undefined : p.price,
      discountedPrice: props.hidePrice ? undefined : p.discountedPrice,
      internalLink: props.noLink ? undefined : p.internalLink,
      isDiscounted: hasDiscount(p.discountedPrice),
    })),
  );

  return (
    <>
      <Spacer size={"lg"} />

      <ContentContainer>
        <PDPProductsCarouselComponent
          headline={props.headline}
          elements={elements}
          width={"full"}
          scrollSnap={true}
          elementsAlignment={"to-left"}
          theme={props.theme === "wide-with-background" ? "wide-with-background" : "normal"}
        />
      </ContentContainer>
    </>
  );
};
